import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { CheckCircle, X } from 'lucide-react';

const MainLayout = () => {
  const [showWelcome, setShowWelcome] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcome(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />
      
      {/* Welcome Toast */}
      {showWelcome && (
        <div className="fixed top-4 right-4 bg-white rounded-lg shadow-lg border border-gray-100 px-4 py-3 flex items-center gap-3 z-50 animate-in slide-in-from-top-2">
          <CheckCircle className="text-green-500" size={20} />
          <span className="text-gray-700 font-medium">Welcome back!</span>
          <button
            onClick={() => setShowWelcome(false)}
            className="text-gray-400 hover:text-gray-600 ml-2"
          >
            <X size={16} />
          </button>
        </div>
      )}

      {/* Main Content */}
      <main className="ml-[208px] p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
